import { Component, Renderer2 } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { UserService } from '../services/User.service';
import { ANGULAR_MODULES } from '../Shared/shared-imports';
import { LoaderComponent } from '../Shared/loader/loader.component';
import Swal from 'sweetalert2';
import { ToastrService } from 'ngx-toastr';
import { take } from 'rxjs';
import { GeneralService } from 'src/app/services/general.service';

@Component({
  selector: 'app-login',
  imports: [ANGULAR_MODULES, LoaderComponent],
  standalone: true,
  templateUrl: './login.html',
  styleUrl: './login.scss'
})
export class Login {
  loginForm: FormGroup;
  marketId;
  public loaderIcon: Promise<boolean>;
  displayUsernameError = false;
  displayPasswordError = false;
  loginError = false;
  inActive = false;
  confirmMailInput: HTMLInputElement
  toasterConfig = {
    closeButton: true,
    timeOut: 4500,
    easing: 'ease-out',
    progressBar: true,
    positionClass: 'toast-top-right',
    tapToDismiss: true,
    showEasing: 'swing',
    hideEasing: 'linear',
    showMethod: 'fadeIn',
    hideMethod: 'slideUp'
  };
  showPassword = false;
  IsAccountDeactivated: boolean = false;

  constructor(private renderer: Renderer2,
    private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private userService: UserService,
    private toastr: ToastrService,
    private generalService: GeneralService,
  ) {
    this.loginForm = this.formBuilder.group({
      username: ['', [Validators.required]],
      password: ['', Validators.required],
      rememberMe: [false]
    });
  }

  ngOnInit(): void {
    this.route.params.subscribe((params: Params) => {
      this.marketId = params['marketId'];
    });
    this.renderer.setStyle(document.body, 'min-height', '100vh');
    this.renderer.setStyle(document.body, 'background', 'linear-gradient(180deg,#0b0b1f,#1a1a3c)');
    this.renderer.setStyle(document.body, 'display', 'flex');
    this.renderer.setStyle(document.body, 'align-items', 'center');
    this.renderer.setStyle(document.body, 'justify-content', 'center');
    this.renderer.setStyle(document.body, 'font-family', 'Arial, sans-serif');
  }

  validateLoginCredentials() {
    if (!this.loginForm.valid) {
      this.displayUsernameError = this.loginForm.get('username').hasError('required');
      this.displayPasswordError = this.loginForm.get('password').hasError('required');
    }
    else {
      this.displayUsernameError = false;
      this.displayPasswordError = false;
    }
  }

  togglePassword() {
    this.showPassword = !this.showPassword;
  }

  validateLogin() {
    this.loaderIcon = Promise.resolve(true);
    if (this.loginForm.valid) {
      this.loginError = false;
      const credentials =
      {
        username: this.loginForm.value['username'],
        password: this.loginForm.value['password'],
        MarketId: this.marketId
      }
      this.userService.getToken(credentials).subscribe(async (response) => {
        if (response) {
          if (!response.InActive) {
            this.loginError = false;
            const rememberMe = this.loginForm.value['rememberMe'];
            if (rememberMe) {
              localStorage.setItem(`rememberMe_${this.marketId}`, 'true');
              localStorage.setItem(`username_${this.marketId}_EmailAdd`, this.loginForm.value['username']);
            } else {
              localStorage.removeItem(`rememberMe_${this.marketId}`);
              localStorage.removeItem(`username_${this.marketId}_EmailAdd}`);
            }
            const vendorId = response.UserId;
            this.userService.setSessionData(this.marketId, vendorId);
            sessionStorage.setItem('token', response.token);
            this.getASCloudLicenseSettings();
            this.router.navigate(['/ops/dashboard']);
          }
          else {
            this.inActive = response.InActive;
          }
          this.loaderIcon = Promise.resolve(false);
        }
        else {
          this.loginError = true;
          this.loaderIcon = Promise.resolve(false);
        }
      });
    }
    else {
      this.displayUsernameError = this.loginForm.get('username').hasError('required');
      this.displayPasswordError = this.loginForm.get('password').hasError('required');
      this.loaderIcon = Promise.resolve(false);
    }
  }

  getASCloudLicenseSettings() {
    this.generalService.getASCloudLicenseSettings(this.marketId).pipe(take(1)).subscribe();
  }

  ForgotPassword(event) {
    event.preventDefault();
    Swal.fire<boolean>({
      title: 'Confirm Mail',
      html: `
       <input type="text" id="email" class="swal2-input" style="width:82%" placeholder="Email">
       <small style="color : #106EBE !important">Your new login password will be sent to your registered email address. <i class="fa fa-warning " style="color: red"></i> Please check your email inbox!!</small>
     `,
      confirmButtonText: 'Confirm',
      focusConfirm: false,
      showCloseButton: true,
      didOpen: () => {
        const popup = Swal.getPopup()!;
        this.confirmMailInput = popup.querySelector('#email') as HTMLInputElement;
        this.confirmMailInput.onkeyup = (event) => event.key === 'Enter' && Swal.clickConfirm();
      },
      preConfirm: () => {
        const confirmMail = this.confirmMailInput?.value
        if (!confirmMail) {
          Swal.showValidationMessage(`Please enter email address`);
          return false;
        }
        else {
          return true;
        }
      },
    }).then((result) => {
      if (result.value) {
        Swal.close();
        this.userService.forgotPassword(this.marketId, this.confirmMailInput?.value).pipe(take(1)).subscribe((res: any) => {
          var response = res.Success;
          if (response) {
            this.toastr.success(res.Message, $localize`Success`, this.toasterConfig);
          }
          else {
            this.toastr.error(res.Message, $localize`Error`, this.toasterConfig)
          }
        });
      }
    });
  }

  ngOnDestroy(): void {
    this.renderer.removeStyle(document.body, 'min-height');
    this.renderer.removeStyle(document.body, 'background');
    this.renderer.removeStyle(document.body, 'display');
    this.renderer.removeStyle(document.body, 'align-items');
    this.renderer.removeStyle(document.body, 'justify-content');
    this.renderer.removeStyle(document.body, 'font-family');
  }
}
